import type { ReactNode } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/ui/primitives/alert-dialog';
import { buttonVariants } from '@/shared/ui/primitives/button';

/** Props do diálogo de confirmação. */
export interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmLabel: string;
  onConfirm: () => void;
  /** `destructive` (padrão) para exclusões e desativações; `default` para confirmações comuns. */
  variant?: 'destructive' | 'default';
  /** Enquanto a ação roda: botões desabilitados e o diálogo segue aberto. */
  pending?: boolean;
}

/** Confirmação explícita de ação (AlertDialog: exige escolha). */
export function ConfirmDialog(props: ConfirmDialogProps): ReactNode {
  return (
    <AlertDialog open={props.open} onOpenChange={props.onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{props.title}</AlertDialogTitle>
          <AlertDialogDescription>{props.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={props.pending}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            className={buttonVariants({ variant: props.variant ?? 'destructive' })}
            disabled={props.pending}
            aria-busy={props.pending}
            onClick={props.onConfirm}
          >
            {props.confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
